import React, { useCallback, useContext, useEffect } from 'react'

import {
  useFormDataV2,
  useFormValidation,
  validateEmailWithLocale,
  validateIsNotBlankWithLocale,
  validateNewPasswordWithLocale,
} from '@monorepo/utils'
import Input from '../Input'
import { ContextApp } from '@monorepo/service'
import { ApiCore, Locale, useRegister } from '@monorepo/api'
import RegisterButton from '../RegisterButton'
import PasswordInputToggle from '../PasswordInputToggle'
import { bonus } from '../../constants'

declare const window: Window &
  typeof globalThis & {
    updateContent?: any
  }

const VALIDATORS = {
  rules: {
    email: [validateIsNotBlankWithLocale, validateEmailWithLocale],
    password: [validateIsNotBlankWithLocale, validateNewPasswordWithLocale],
  },
  defaultData: {
    email: '',
    password: '',
  },
}

const FormEmail: React.FC = () => {
  const { sid, setDataRegister } = useContext(ContextApp)

  const { handleRequest, commonErrorMsg, fieldErrorMsg, isLoading } = useRegister({
    sid,
    bonusId: bonus?.bonusId,
    setDataRegister,
  })

  const emailErrorMessage = fieldErrorMsg ? fieldErrorMsg['email'] : null
  const passwordErrorMessage = fieldErrorMsg ? fieldErrorMsg['password'] : null

  const { validateForm } = useFormValidation(VALIDATORS.rules)
  const { form, onValidate, onInputChange } = useFormDataV2({
    validateForm,
    defaultData: VALIDATORS.defaultData,
  })

  const handleSubmit = useCallback(() => {
    onValidate(
      'email',
      'password',
    )((data) => {
      handleRequest({
        account_registered_by: ApiCore.PublicAccountRegistrationTypeEnum.Email,
        language: Locale.get(),
        country_of_residence: 'KAZ',
        currency: 'KZT',
        privacy_policy: true,
        terms_and_conditions: true,
        receive_promos_enabled: true,
        ...data,
      })
    })
  }, [handleRequest, onValidate])

  const fields = ['email', 'password']
  const touched = fields.some((field) => form.statuses[field as keyof typeof form.statuses])
  const isFormValid = fields.every(
    (field) => form.statuses[field as keyof typeof form.statuses] === 'valid',
  )

  useEffect(() => {
    window.updateContent?.()
  }, [form.errors])

  return (
    <>
      <div
        className={`ejForm__fields ${touched ? (isFormValid ? 'validForm' : 'invalidForm') : ''}`}
      >
        <Input
          id="email"
          type="email"
          className="input"
          data-i18n-placeholder="form.placeholders.email"
          placeholder="Почта"
          value={form.data.email}
          errorMsg={emailErrorMessage ?? form.errors.email}
          inputMode="email"
          onBeforeInput={(e: any) => {
            if (e.data && /[А-Яа-яЁё]/.test(e.data)) {
              e.preventDefault()
            }
          }}
          onChange={(e) => {
            const raw = e.target.value
            const filtered = raw.replace(/[А-Яа-яЁё]/g, '')
            onInputChange('email')({ target: { value: filtered } } as any)
          }}
        />
        <PasswordInputToggle
          value={form.data.password}
          onChange={(val) => onInputChange('password')({ target: { value: val } } as any)}
          errorMsg={commonErrorMsg ?? passwordErrorMessage ?? form.errors.password}
          data-i18n-placeholder="form.placeholders.password"
        />
        {/* <Input
                    id="password"
                    className="input"
                    data-i18n-placeholder="form.placeholders.password"
                    type="password"
                    autoComplete="new-password"
                    placeholder="Пароль"
                    errorMsg={errorMsg ?? form.errors.password}
                    maxLength={100}
                    onChange={e => {
                        const raw = e.target.value;
                        const filtered = raw.replace(/[А-Яа-яЁё]/g, '');
                        onInputChange('password')({ target: { value: filtered } } as any);
                    }}
                /> */}
      </div>
      <RegisterButton handleSubmit={handleSubmit} disabled={isLoading} />
    </>
  )
}

export default FormEmail
